module.exports = __webpack_public_path__ + "static/media/clock.70dd02a5.svg";